import InternCoursePage from '../InternCoursePage';
import useInternCourses from '../../../../hooks/useInternCourses';

export default function InternTanzabendPage() {
  const { courses, loading, error, reload } = useInternCourses('tanzabend');
  return (
    <InternCoursePage
      courses={courses}
      loading={loading}
      error={error}
      pageTitle={'Tanzabend'}
      category={'tanzabend'}
      reload={reload}
    />
  );
}
